// Re-export from shared package
// The provider needs to be wrapped to inject environment variables
import {
  PostHogProvider as SharedPostHogProvider,
  usePostHog,
  CONSENT_KEY,
  resolveWebEnvironment,
  POSTHOG_HOSTS,
} from '@neumind/shared/analytics';

interface PostHogProviderProps {
  children: React.ReactNode;
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  return (
    <SharedPostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      apiHost={import.meta.env.VITE_PUBLIC_POSTHOG_HOST || POSTHOG_HOSTS.ui}
      // ADR 0012 environment super-property (ISS-260810-64q7 www leg). One
      // derivation point for this surface — sites/www/src/utils/sentry.ts
      // routes through the same `resolveWebEnvironment`.
      environment={resolveWebEnvironment(
        import.meta.env.VITE_ENVIRONMENT,
        import.meta.env.MODE
      )}
    >
      {children}
    </SharedPostHogProvider>
  );
}

export { usePostHog, CONSENT_KEY };
